import { ReactNode } from 'react'
import Navigation from './Navigation'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-tg-bg flex flex-col">
      {/* Основной контент */}
      <main
        className="flex-1"
        style={{
          paddingBottom: 'calc(56px + env(safe-area-inset-bottom, 0px))'
        }}
      >
        {children}
      </main>

      {/* Навигация внизу */}
      <Navigation />
    </div>
  )
}
